import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  ogTitle, 
  ogDescription, 
  ogImage,
  canonical 
}) => {
  const siteTitle = "Duru Halı Yıkama";
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const siteUrl = "https://www.bahcesehirduruhaliyikama.com";
  const defaultDescription = "Bahçeşehir, Beylikdüzü, Esenyurt, Başakşehir ve Büyükçekmece'de profesyonel halı ve koltuk yıkama hizmeti. Ücretsiz alım-teslim.";
  const defaultKeywords = "halı yıkama bahçeşehir, koltuk yıkama bahçeşehir, halı yıkama beylikdüzü, halı yıkama esenyurt, halı yıkama başakşehir, halı yıkama büyükçekmece, koltuk temizleme, yorgan yıkama";

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical || siteUrl} />
      <meta property="og:title" content={ogTitle || fullTitle} />
      <meta property="og:description" content={ogDescription || description || defaultDescription} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:locale" content="tr_TR" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonical || siteUrl} />
      <meta property="twitter:title" content={ogTitle || fullTitle} />
      <meta property="twitter:description" content={ogDescription || description || defaultDescription} />
      {ogImage && <meta property="twitter:image" content={ogImage} />}

      {/* Canonical */}
      <link rel="canonical" href={canonical || siteUrl} />

      {/* Additional SEO Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Turkish" />
      <meta name="geo.region" content="TR-34" />
      <meta name="geo.placename" content="Bahçeşehir, İstanbul" />
      <meta name="author" content="Duru Halı Yıkama" />
      
      {/* Schema.org markup for LocalBusiness */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Duru Halı Yıkama",
          "image": ogImage || `${siteUrl}/logo.png`,
          "description": description || defaultDescription,
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Bahçeşehir 2.kısım mahallesi şirinevler sokak no:7",
            "addressLocality": "Başakşehir",
            "addressRegion": "İstanbul",
            "addressCountry": "TR"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "41.0477",
            "longitude": "28.8025"
          },
          "telephone": "+905438870853",
          "url": siteUrl,
          "priceRange": "$$",
          "areaServed": [
            {
              "@type": "City",
              "name": "Bahçeşehir"
            },
            {
              "@type": "City",
              "name": "Beylikdüzü"
            },
            {
              "@type": "City",
              "name": "Esenyurt"
            },
            {
              "@type": "City",
              "name": "Başakşehir"
            },
            {
              "@type": "City",
              "name": "Büyükçekmece"
            }
          ],
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
              "opens": "08:00",
              "closes": "19:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Sunday",
              "opens": "09:00",
              "closes": "17:00"
            }
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
